import { ColumnsType } from 'antd/lib/table';
import { Moment } from 'moment';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { FormatTime } from 'components/organisms/timesheets/common/format-time';
import { FooterRow } from 'components/organisms/timesheets/common/timesheet-table';
import { TimesheetWeekSummary } from '../types';

const Footer = styled(FooterRow)``;

export const FooterTable: FC<{
  startDate: Moment;
  timeSheetSummary: TimesheetWeekSummary;
}> = ({ startDate, timeSheetSummary }) => {
  const days: ColumnsType<any> = [...Array(7)].map((value, index) => ({
    title: (
      <FormatTime
        value={
          timeSheetSummary.totalMinutesForDays[
            startDate.add(index, 'days').format('YYYY-MM-DD')
          ] ?? 0
        }
        showHypenIfZero={false}
      />
    ),
    width: '6%',
    align: 'left',
  }));
  const columns: ColumnsType<any> = [
    {
      title: <FormattedMessage id="timesheets.column.total_time" />,
      width: '32%',
    },
    ...days,
    {
      title: (
        <FormatTime
          value={timeSheetSummary.totalMinutesForWeek}
          showHypenIfZero={false}
        />
      ),
      width: '12%',
      align: 'left',
    },
  ];

  return (
    <Footer
      data-cy="timesheet.footer.table"
      columns={columns}
      dataSource={[]}
      pagination={false}
    />
  );
};
